<template>
    <div
        class="header__top_account_menu_box"
        :class="[
            'header__top_account_menu_box',
            accountMenuBoxActive ? 'header__top_account_menu_box--active' : 'header__top_account_menu_box--inactive',
            accountMenuBoxTouched ? 'header__top_account_menu_box--touched' : ''
        ]"
    >
        <template v-if="accountMenuBoxActive">
            <header-top-account-menu-box-details/>
            <header-top-account-menu-box-nav v-if="user.isTokenFromNewLms()"/>
            <header-top-account-menu-box-enrolmentrequests v-if="user.isTokenFromNewLms() && (user.isLearningExperienceAdministrator() || user.isOrgUnitManager())"/>
            <header-top-account-menu-box-workspace v-if="user.isTokenFromNewLms()"/>
            <header-top-account-menu-box-actions/>
        </template>
    </div>
</template>

<script>
import HeaderTopAccountMenuBoxNav from '@/components/default/layout/header/HeaderTopAccountMenuBoxNav'
import HeaderTopAccountMenuBoxWorkspace from '@/components/default/layout/header/HeaderTopAccountMenuBoxAccess'
import HeaderTopAccountMenuBoxActions from '@/components/default/layout/header/HeaderTopAccountMenuBoxActions'
import HeaderTopAccountMenuBoxDetails from '@/components/default/layout/header/HeaderTopAccountMenuBoxDetails'
import HeaderTopAccountMenuBoxEnrolmentrequests from '@/components/default/layout/header/HeaderTopAccountMenuBoxEnrolmentrequests'
import { User } from '@/User'
import HeaderTopAccountMenuBoxSessiontimer from '@/components/default/layout/header/HeaderTopAccountMenuBoxSessionTimer'

export default {
  name: 'header-top-account-menu-box',
  components: { HeaderTopAccountMenuBoxSessiontimer, HeaderTopAccountMenuBoxEnrolmentrequests, HeaderTopAccountMenuBoxDetails, HeaderTopAccountMenuBoxActions, HeaderTopAccountMenuBoxWorkspace, HeaderTopAccountMenuBoxNav },
  data () {
    return {
      user: new User()
    }
  },
  props: {
    accountMenuBoxActive: {
      type: Boolean
    },
    accountMenuBoxTouched: {
      type: Boolean
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/layout/header/headertopaccountmenubox";
</style>
